import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { CtoRoutingModule } from './cto-routing.module';
import { CtoComponent } from './cto.component';
import { SharedModule } from '../../shared/shared.module';
import { ContractComponent } from './contract/contract.component';
import { CtoDetailsComponent } from './cto-details/cto-details.component';
import { NewCtoComponent } from './new-cto/new-cto.component';
import { EditCtoComponent } from './edit-cto/edit-cto.component';
import { CtoStatusComponent } from './cto-status/cto-status.component';
import { CtoRetailPlaceComponent } from './cto-retail-place/cto-retail-place.component';
import { CtoKkmComponent } from './cto-kkm/cto-kkm.component';
import { CtoKkmHistoryComponent } from './cto-kkm-history/cto-kkm-history.component';
import { CtoInfoComponent } from './cto-info/cto-info.component';
import { CtoDetailHeaderComponent } from './cto-detail-header/cto-detail-header.component';
import { ParamBlockComponent } from './param-block/param-block.component';

@NgModule({
  declarations: [
    CtoComponent,
    ContractComponent,
    CtoDetailsComponent,
    CtoStatusComponent,
    CtoRetailPlaceComponent,
    CtoKkmComponent,
    CtoKkmHistoryComponent,
    CtoInfoComponent,
    NewCtoComponent,
    EditCtoComponent,
    CtoDetailHeaderComponent,
    ParamBlockComponent,
  ],
  imports: [
    FormsModule,
    CommonModule,
    CtoRoutingModule,
    MatMenuModule,
    TranslateModule,
    SharedModule,
    ReactiveFormsModule,
  ],
  providers: [],
})
export class CtoModule { }
